import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppComponent } from './../../app.component';

import { LoginTransversalRoutingModule } from './login-transvelsal-routing.module';

// Modules
import { SharedModule } from '@modules/shared.module';

// Components
import { LoginComponent } from './login/login.component';
import { RestorePassComponent } from './restore-pass/restore-pass.component';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@NgModule({
  declarations: [
    LoginComponent,
    RestorePassComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LoginTransversalRoutingModule,
    ReactiveFormsModule,
    MatInputModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: "es-ES" }, //Format configuration in es-ES
  ],
  bootstrap: [AppComponent]
})
export class LoginTransversalModule { }